import DownloadManagerRepository from "../Repository/DownloadManagerRepository";
import DocumentDownload from "../Entity/DocumentDownload";

export default class RemoveDownloadManager {
    public constructor(
        private downloadManagerRepository: DownloadManagerRepository
    ) {
    }

    public remove(document: DocumentDownload): void {
        this.downloadManagerRepository.remove(document.getResourceId());
    }
}